import Backbone from 'backbone'

/**
 * @see ChartBreakdownRange.kt
 */
const ChartDesignerRange = Backbone.Model.extend(/** @lends ChartDesignerRange.prototype */{

})

export default ChartDesignerRange

ChartDesignerRange.__filename__ = 'charts/model/chart-designer-range.js'
